import { createSlice } from "@reduxjs/toolkit";
import { balanceStateName, balanceInitialState } from "./constants";

const balanceSlice = createSlice({
  name: balanceStateName,
  initialState: balanceInitialState,
  reducers: {
    setBalance(state, action) {
      state.balance = action.payload;
    },
  },
});

export const { name, reducer, actions } = balanceSlice;
